"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinanceEligibilityFetchDTO = exports.FinanceEligibilityOptionsDTO = exports.FinanceEligibilityFilterDTO = exports.FinanceEligibilityRequestResponseDTO = exports.FinanceEligibilityRequestUpdateDTO = exports.FinanceEligibilityRequestCreateDTO = exports.Status = exports.EligibilityStatus = exports.YesNo = exports.EmployeeCount = exports.SalaryType = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const global_1 = require("../../../../global");
const models_1 = require("../../../models");
var SalaryType;
(function (SalaryType) {
    SalaryType["WPS"] = "wps";
    SalaryType["BANK_TRANSFER"] = "bank_transfer";
    SalaryType["CASH"] = "cash";
    SalaryType["OTHER"] = "other";
})(SalaryType = exports.SalaryType || (exports.SalaryType = {}));
var EmployeeCount;
(function (EmployeeCount) {
    EmployeeCount["LESS_THAN_10"] = "less_than_10";
    EmployeeCount["BETWEEN_10_50"] = "between_10_50";
    EmployeeCount["MORE_THAN_50"] = "more_than_50";
})(EmployeeCount = exports.EmployeeCount || (exports.EmployeeCount = {}));
var YesNo;
(function (YesNo) {
    YesNo["YES"] = "yes";
    YesNo["NO"] = "no";
})(YesNo = exports.YesNo || (exports.YesNo = {}));
var EligibilityStatus;
(function (EligibilityStatus) {
    EligibilityStatus[EligibilityStatus["ELIGIBLE"] = 1] = "ELIGIBLE";
    EligibilityStatus[EligibilityStatus["NOT_ELIGIBLE"] = 0] = "NOT_ELIGIBLE";
})(EligibilityStatus = exports.EligibilityStatus || (exports.EligibilityStatus = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "pending";
    Status["APPROVED"] = "approved";
    Status["REJECTED"] = "rejected";
})(Status = exports.Status || (exports.Status = {}));
class FinanceEligibilityRequestCreateDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityRequestCreateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "makeId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "modelId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(2),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "fullName", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[0-9+\s-]{8,}$/),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "contactNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestCreateDTO.prototype, "currentSalary", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "existingLoans", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestCreateDTO.prototype, "totalMonthlyInstallments", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "hasCreditScore", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestCreateDTO.prototype, "totalCreditLimit", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(SalaryType),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "salaryType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "previousDisputes", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EmployeeCount),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "employeeCount", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], FinanceEligibilityRequestCreateDTO.prototype, "isCompanyOlderThanOneYear", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestCreateDTO.prototype, "hasLandline", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], FinanceEligibilityRequestCreateDTO.prototype, "documents", void 0);
exports.FinanceEligibilityRequestCreateDTO = FinanceEligibilityRequestCreateDTO;
class FinanceEligibilityRequestUpdateDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityRequestUpdateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "makeId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "modelId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(2),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "fullName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[0-9+\s-]{8,}$/),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "contactNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestUpdateDTO.prototype, "currentSalary", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "existingLoans", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestUpdateDTO.prototype, "totalMonthlyInstallments", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "hasCreditScore", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestUpdateDTO.prototype, "totalCreditLimit", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(SalaryType),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "salaryType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "previousDisputes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EmployeeCount),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "employeeCount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], FinanceEligibilityRequestUpdateDTO.prototype, "isCompanyOlderThanOneYear", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "hasLandline", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EligibilityStatus),
    __metadata("design:type", Number)
], FinanceEligibilityRequestUpdateDTO.prototype, "eligibility", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], FinanceEligibilityRequestUpdateDTO.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(["pending", "approved", "rejected"]),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestUpdateDTO.prototype, "rejectionReason", void 0);
exports.FinanceEligibilityRequestUpdateDTO = FinanceEligibilityRequestUpdateDTO;
class FinanceEligibilityRequestResponseDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityRequestResponseDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "makeId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "modelId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FinanceEligibilityRequestResponseDTO.prototype, "make", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FinanceEligibilityRequestResponseDTO.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "fullName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "contactNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestResponseDTO.prototype, "currentSalary", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "existingLoans", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestResponseDTO.prototype, "totalMonthlyInstallments", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "hasCreditScore", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], FinanceEligibilityRequestResponseDTO.prototype, "totalCreditLimit", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(SalaryType),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "salaryType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "previousDisputes", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EmployeeCount),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "employeeCount", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], FinanceEligibilityRequestResponseDTO.prototype, "isCompanyOlderThanOneYear", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(YesNo),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "hasLandline", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], FinanceEligibilityRequestResponseDTO.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EligibilityStatus),
    __metadata("design:type", Number)
], FinanceEligibilityRequestResponseDTO.prototype, "eligibility", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FinanceEligibilityRequestResponseDTO.prototype, "user", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", models_1.Lead)
], FinanceEligibilityRequestResponseDTO.prototype, "lead", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(Status),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FinanceEligibilityRequestResponseDTO.prototype, "rejectionReason", void 0);
exports.FinanceEligibilityRequestResponseDTO = FinanceEligibilityRequestResponseDTO;
class FinanceEligibilityFilterDTO {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityFilterDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityFilterDTO.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityFilterDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityFilterDTO.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EligibilityStatus),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], FinanceEligibilityFilterDTO.prototype, "eligibility", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(SalaryType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FinanceEligibilityFilterDTO.prototype, "salaryType", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], FinanceEligibilityFilterDTO.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", global_1.DateFilter)
], FinanceEligibilityFilterDTO.prototype, "createdAt", void 0);
exports.FinanceEligibilityFilterDTO = FinanceEligibilityFilterDTO;
class FinanceEligibilityOptionsDTO extends global_1.PaginationOptions {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityFilterDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FinanceEligibilityOptionsDTO.prototype, "sort", void 0);
exports.FinanceEligibilityOptionsDTO = FinanceEligibilityOptionsDTO;
class FinanceEligibilityFetchDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(FinanceEligibilityFetchDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
}
exports.FinanceEligibilityFetchDTO = FinanceEligibilityFetchDTO;
